import React from 'react';
import {DataItem, TimeInput} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import moment from 'moment';
import {IDeveloperField} from 'dromo-uploader-react';

interface DisplayProps {
  value: string;
}

interface Props {
  valueKey?: string;
  name?: string;
  date?: Date | undefined;
}

export const Import = (
  key: string = 'startTime',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Time (HH:mm)',
  key,
  validators: [
    {
      validate: 'required',
    },
    {
      validate: 'regex_match',
      regex: '^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$',
      errorMessage: 'Must be a valid time.',
    },
  ],
});

const resolveDisplayValue = (value: string) => {
  return moment(value).format('ll');
};

const StartTimeDisplay = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>Start Time</Text>
      <Text style={[Typography.P3]}>{resolveDisplayValue(value)}</Text>
    </DataItem>
  );
};

const StartTimeInput = ({valueKey, name = 'Start Time', date}: Props) => {
  return (
    <TimeInput
      valueKey={(valueKey ? valueKey + '.' : '') + 'startTime'}
      name={name}
      date={date}
      required={true}
    />
  );
};

export const validation = () => Yup.string().required('Start time is required');

export const Display = StartTimeDisplay;
export const Input = StartTimeInput;
export const Value = resolveDisplayValue;

export default StartTimeInput;
